import React from "react";
import PropTypes from "prop-types";

import { CircularProgress } from "@mui/material";

import useStyles from "./styles";

const PreLoader = ({ size, color = "primary" }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.progressWrapper}>
        <CircularProgress size={size} color={color} />
      </div>
    </div>
  );
};

PreLoader.propTypes = {
  size: PropTypes.number,
};

export default PreLoader;
